import type { ReactNode } from 'react';

import { handleMpaInterceptInWizard } from '@/data/dal/mpaIntercept';

export interface ConfirmationActionProps {
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
  confirmSnackbarText?: string;
  // Shown instead of the generic message when an approval rule intercepted
  // the confirmed action and the user submitted it for approval.
  approvalSnackbarText?: ReactNode;
}

// The failure for the dialog to show, or null once the action succeeded or an
// approval rule intercepted it.
export const runConfirmationAction = async (
  props: ConfirmationActionProps,
  snackbar: { showMessage: (msg: ReactNode) => void }
): Promise<{ error: unknown } | null> => {
  try {
    await props.onConfirm();
  } catch (error) {
    if (
      handleMpaInterceptInWizard(
        error,
        props.onCancel,
        snackbar,
        props.approvalSnackbarText
      )
    ) {
      return null;
    }
    return { error };
  }
  if (props.confirmSnackbarText) {
    snackbar.showMessage(props.confirmSnackbarText);
  }
  return null;
};
